import { atom } from "jotai";
import { ListFilter, ProductList } from "../domain";

const list: ProductList = {
  dataList: [],
  paging: {
    currentPageNumber: 1,
    totalPagesNumber: 1,
    pageSize: 1,
    totalCount: 1,
  }
};

export const listAtom = atom<ProductList>(list);
export const listFilterAtom = atom<ListFilter>({
  filterList: [],
  orderList: [{ type: 2, key: "PublishDate" }],
  paging: {
    currentPageNumber: 1,
    pageSize: 10
  },
  // search: {
  //   value: '',
  //   keyList: []
  // },
});